import React, { useRef, useState, useEffect } from "react";
import InnerLayout from "../../../layouts/inner-layout";
import TabsComponent from "../../../helper-components/tabs-component";

import { Navigate, useNavigate } from "react-router-dom";
import { ChevronLeftIcon, Search } from "lucide-react";
import DepartmentTable from "../../../department-role.js/departmentTable";
import RolesTable from "../../../department-role.js/rolesTable";
import LoadingOverlay from "../../../helper-components/overlay-loading";
import SearchField from "../../../forms/search-field";
import { downloadAllTemplates } from "../../../helper-components/helper-function";
import useCsvUpload from "../../../helper-components/upload-csv-custom-hook";
import excelImg from "../../../../assets/icons/excel.png";
import LoadingButtonSpinner from "../../../helper-components/loading-button-spinner";
import successToast from "../../../helper-components/success-toast";
import DownloadIcon from "../../../../assets/icons/download-icon";
import DepartmentAndRoles from "../../../department-role.js/department-and-roles-table";

import { useHotkeys } from "react-hotkeys-hook";
import {
  drugDocumentUploadAction,
  leadDocumentUploadAction,
} from "../../../../redux/actions/settings-action";
import ScheduledDrugComp from "./components/scheduled-drug-comp";
import LeadComp from "./components/lead-comp";
import {
  specializationDocumentUploadAction,
  subSpecialDocumentUploadAction,
} from "../../../../redux/actions/settings-action";
import SpecialComp from "./components/specialization-comp";
import SubSpecialComp from "./components/sub-special-comp";
import errorToast from "../../../helper-components/error-toast";
import PackingTypeComp from "./components/packing-type-comp";
import PackingComp from "./components/packing-comp";
import CartonTypeComp from "./components/carton-comp";

function PackInfo() {
  const [currentTab, setCurrentTab] = useState("Packing Type");
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();

  // State to track unsaved changes for each tab
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState({
    "Packing Type": false,
    Packing: false,
    "Carton Type": false,
  });

  // const searchRef = useRef(null);

  const packingType = [
    {
      documentType: "Packing Type",
      expectedHeaders: ["code", "name", "discription"],
    },
  ];
  const packing = [
    {
      documentType: "Packing",
      expectedHeaders: ["code", "name", "discription"],
    },
  ];
  const carton = [
    {
      documentType: "Corton Type",
      expectedHeaders: ["code", "name", "discription"],
    },
  ];

  const itemTemplate =
    currentTab === "Packing"
      ? packing
      : currentTab === "Carton Type"
      ? carton
      : packingType;

  const actionType =
    currentTab === "Packing"
      ? specializationDocumentUploadAction
      : currentTab === "Carton Type"
      ? subSpecialDocumentUploadAction
      : subSpecialDocumentUploadAction;

  const { handleFileUpload } = useCsvUpload(
    actionType,
    itemTemplate?.[0]?.expectedHeaders
  );

  const onSuccess = (data) => {
    successToast(data?.data?.message);
  };
  const onError = (data) => {
    errorToast(data?.data?.message);
  };

  // Handle tab switching with unsaved changes check
  const handleTabSwitch = (newTab) => {
    // Check if current tab has unsaved changes
    if (hasUnsavedChanges[currentTab]) {
      const shouldSwitch = window.confirm(
        `You have unsaved changes in ${currentTab}. Are you sure you want to switch to ${newTab} without saving?`
      );

      if (!shouldSwitch) {
        return; // Don't switch tabs
      }
    }

    // Switch to new tab
    setCurrentTab(newTab);
  };

  // Function to update unsaved changes state for a specific tab
  const handleFormChange = (tabName, hasChanges) => {
    setHasUnsavedChanges((prev) => ({
      ...prev,
      [tabName]: hasChanges,
    }));
  };

  // useHotkeys("/", (event) => {
  //   event.preventDefault();
  //   if (searchRef.current) {
  //     searchRef.current.focus();
  //   }
  // });
  return (
    <InnerLayout title="Settings">
      <div className="flex flex-col gap-2 mx-6 mt-4">
        <LoadingOverlay loading={loading} />

        <div className="flex justify-between items-center">
          <div className=" flex items-center gap-2 text-sml ">
            <button
              className="flex items-center gap-2"
              onClick={() => {
                navigate("/settings");
              }}
            >
              <ChevronLeftIcon className="h-5 w-5 inline-block " />
              Data Setup Settings /
            </button>
            <span className="cursor-pointer">{" " + "Packing Info"}</span>
          </div>
          <div className="flex items-center gap-3 pr-3">
            <div
              style={{ minWidth: "18rem", height: "2.5rem" }}
              className={`border border-[var(--search-input-border)] flex  justify-between items-center rounded-md  w-10 `}
            >
              <input
                // ref={searchRef}
                placeholder={`Search (/)`}
                className=" table_search_input px-3 py-2 !border-none !outline-none !ring-0 text-[length:var(--search-label-font-size)] font-[var(--search-place-font-weight)]"
                type="text"
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e?.target?.value);
                }}
              />
              <span className="px-2">
                {" "}
                {<Search size="16" color="#9CA3AF" />}
              </span>
            </div>
            <div className=" flex flex-row gap-3">
              <div>
                <input
                  type="file"
                  accept=".csv"
                  onChange={(e) => handleFileUpload(e, onSuccess, onError)} // Pass onSuccess and onError functions
                  className="hidden"
                  id="csv-upload"
                />
                <label htmlFor="csv-upload">
                  <div className="border-027A48 border-2 rounded-md flex items-center gap-2 text-nowrap px-5 py-2 fw_700">
                    <img
                      width={20}
                      height={30}
                      src={excelImg}
                      alt="excel-icon"
                    />
                    {loading ? (
                      <LoadingButtonSpinner className="  h-6 w-6 border-t-2 border-027A48" />
                    ) : (
                      <span>Import</span>
                    )}
                  </div>
                </label>
              </div>
              <button
                type="button"
                onClick={() => {
                  downloadAllTemplates(itemTemplate);
                }}
                className="border-027A48 border-2 rounded-md px-2 py-1"
              >
                <DownloadIcon fill="var(--success-color)" />
              </button>
            </div>
          </div>
        </div>
        <div>
          <TabsComponent
            handleClickfn={(item) => {
              handleTabSwitch(item);
            }}
            itemTabs={itemTabs}
            setCurrentTab={setCurrentTab}
            currentTab={currentTab}
          />
          {currentTab === "Packing Type" && (
            <div>
              <PackingTypeComp
                pageLoading={loading}
                setPageLoading={setLoading}
                searchValue={searchValue}
                reload={reload}
                setReload={setReload}
                onFormChange={(hasChanges) =>
                  handleFormChange("Packing Type", hasChanges)
                }
              />
            </div>
          )}
          {currentTab === "Packing" && (
            <div>
              <PackingComp
                pageLoading={loading}
                setPageLoading={setLoading}
                searchValue={searchValue}
                reload={reload}
                setReload={setReload}
                onFormChange={(hasChanges) =>
                  handleFormChange("Packing", hasChanges)
                }
              />
            </div>
          )}
          {currentTab === "Carton Type" && (
            <div>
              <CartonTypeComp
                pageLoading={loading}
                setPageLoading={setLoading}
                searchValue={searchValue}
                reload={reload}
                setReload={setReload}
                onFormChange={(hasChanges) =>
                  handleFormChange("Carton Type", hasChanges)
                }
              />
            </div>
          )}
        </div>
      </div>
    </InnerLayout>
  );
}

export default PackInfo;
const itemTabs = ["Packing Type", "Packing", "Carton Type"];
